var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},[_c('h1',[_vm._v("ROLL STATISTICS")]),_c('p',[_vm._v("Curious to see how others have rolled? Select the number of dice below and see stats on all the rolls in the database!")]),_c('RollStatistics')],1)}
var staticRenderFns = []

export { render, staticRenderFns }